module.exports = __webpack_public_path__ + "img/jane-stuart-woolsey.1cf62c38.png";